

















import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import usersAPI from "@/api/users";

/**
 * Delete character modal.
 */
@Component
export default class DeleteCharacterDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections

	/// Properties
	@Prop()
	onAfterDelete!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	character: any | null = null;

	/// Methods
	async open(character: any) {
		this.$refs.modal.open();
		this.character = character;
	}

	close() {
		this.$refs.modal.close();
	}

	async handleDeleteCharacterClick() {
		this.isLoading = true;
		try {
			await usersAPI.deleteCharacter(this.character.id);
			this.close();
			if (this.onAfterDelete) {
				await this.onAfterDelete();
			}
		}
		catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
